import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import { Title } from '../../../../packages/kiti/components/presentation/Text'
import Line from '../../../../packages/kiti/components/helpers/Line'
import TextArea from '../../../../packages/kiti/components/form/Textarea'

const BasicInfoSection = () => {
  const { t } = useTranslation('editStocks')
  return (
    <>
      <Separator weight={2} />
      <Title size="small" bold color="dark3">
        {t('sections.basicInfo')}
      </Title>
      <Line />
      <Separator weight={2} />
      <Grid paddingGutter={0.5} wrap>
        <Col width="33%" wrapOn="sm">
          <FormItem label={t('fields.name')} field="name" />
        </Col>
        <Col width="33%" wrapOn="sm">
          <FormItem label={t('fields.code')} field="code" />
        </Col>
        <Col width="33%" wrapOn="sm">
          <FormItem label={t('fields.subCategory')} field="subCategory" />
        </Col>
        <Col width="33%" wrapOn="sm">
          <FormItem label={t('fields.brand')} field="brand" />
        </Col>
        <Col width="33%" wrapOn="sm">
          <FormItem label={t('fields.model')} field="model" />
        </Col>
        <Col width="33%" wrapOn="sm">
          <FormItem label={t('fields.supplier')} field="supplier" />
        </Col>
        <Col width="33%" wrapOn="sm">
          <FormItem label={t('fields.sizeUnit')} field="sizeUnit" />
        </Col>
        <Col width="100%" wrapOn="sm">
          <FormItem Input={TextArea} label={t('fields.description')} field="description" limit={255} rows={2} />
        </Col>
      </Grid>
    </>
  )
}

export default BasicInfoSection
